import React from 'react';
import './Threads.css';

const WIDTH = 1200;
const HEIGHT = 400;
const LINES = 14;
const STEPS = 48;

// Static take on the brand wave: a bundle of thin lines that fan out and back in
const buildPath = (index) => {
  const t = index / (LINES - 1) - 0.5;
  const points = [];
  for (let i = 0; i <= STEPS; i++) {
    const p = i / STEPS;
    const envelope = Math.sin(p * Math.PI);
    const y =
      HEIGHT / 2 +
      Math.sin(p * Math.PI * 2.2 + t * 1.6) * 70 * envelope +
      t * 190 * envelope * Math.sin(p * Math.PI * 1.3 + 0.6);
    points.push(`${(p * WIDTH).toFixed(1)},${y.toFixed(1)}`);
  }
  return `M${points.join(' L')}`;
};

const PATHS = Array.from({ length: LINES }, (_, i) => buildPath(i));

const Threads = ({ color = [1, 1, 1] }) => {
  const stroke = `rgb(${color.map((c) => Math.round(c * 255)).join(',')})`;
  return (
    <div className="threads-container" aria-hidden="true">
      <svg viewBox={`0 0 ${WIDTH} ${HEIGHT}`} preserveAspectRatio="none">
        {PATHS.map((d, i) => (
          <path key={i} d={d} fill="none" stroke={stroke} strokeWidth="1" vectorEffect="non-scaling-stroke" opacity={0.35 + (i % 3) * 0.2} />
        ))}
      </svg>
    </div>
  );
};

export default Threads;
